// store/auth/selectors.js
import { createSelector } from '@reduxjs/toolkit';

// store/auth/selectors.js - Add these selectors
export const selectNeedsSocialRegistration = (state) => state.auth.needsSocialRegistration;
export const selectSocialUserData = (state) => state.auth.socialUserData;

// Base selector to access the auth state
const selectAuthState = (state) => state.auth;

// Selector to get the current user
export const selectCurrentUser = createSelector(
  [selectAuthState],
  (authState) => authState.currentUser
);

// Selector to get the authentication status
export const selectIsAuthenticated = createSelector(
  [selectAuthState],
  (authState) => authState.isAuthenticated
);

// Selector to get the loading state
export const selectAuthLoading = createSelector(
  [selectAuthState],
  (authState) => authState.loading
);

// Selector to get the authentication error
export const selectAuthError = createSelector(
  [selectAuthState],
  (authState) => authState.error
);

// Selector to get the user's token
export const selectAuthToken = createSelector(
  [selectAuthState],
  (authState) => authState.token
);

// Selector to get the user's type (e.g., "guest", "provider", etc.)
export const selectUserType = createSelector(
  [selectAuthState],
  (authState) => authState.userType
);

// NEW SELECTORS FOR IMPERSONATION
// Selector to check if user is impersonating
export const selectIsImpersonated = createSelector(
  [selectAuthState],
  (authState) => authState.isImpersonated
);

// Selector to get original admin info
export const selectOriginalAdmin = createSelector(
  [selectAuthState],
  (authState) => authState.originalAdmin
);

// Selector to check if user is admin
export const selectIsAdmin = createSelector(
  [selectAuthState],
  (authState) => {
    const userType = authState.userType;
    const currentUserType = authState.currentUser?.type;
    return userType === 'admin' || currentUserType === 'admin';
  }
);

// Selector to check if user can impersonate (is admin and not already impersonating)
export const selectCanImpersonate = createSelector(
  [selectIsAdmin, selectIsImpersonated],
  (isAdmin, isImpersonated) => isAdmin && !isImpersonated
);